module.exports = __webpack_public_path__ + "img/download.5d6b9a50.svg";